import { render, staticRenderFns } from "./TickerAdminEditRec.vue?vue&type=template&id=581addb6"
import script from "./TickerAdminEditRec.vue?vue&type=script&lang=js"
export * from "./TickerAdminEditRec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports